import { render } from "./JobsList.vue?vue&type=template&id=01d361bc"
import script from "./JobsList.vue?vue&type=script&lang=js"
export * from "./JobsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__